<template>
    <v-dialog max-width="70%" v-model="dialog">
        <v-card min-width="70%">
            <v-card-actions>
                <v-card-text class="ma-0 pa-0 green--text">{{this.user == null ? "" : this.user.email}}</v-card-text>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions>
                <v-card width="100%" outlined elevation="0" style="overflow-y: scroll" height="500px">
                        <template v-for="item in appPermisions">
                            <v-list-item class="ma-0 pa-0">
                                <v-list-item-content class="ma-0 pa-1">
                                    <v-card elevation="0" outlined>
                                        <v-card-actions class="ma-0 pa-0 mx-3">
                                            <div class="blue--text" style="font-size:0.9em">{{item.name}}</div>
                                            <div class="grey--text" style="margin-left: 10px; font-size:0.8em">{{item.message}}</div>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click="onPressCheckbox(item)">
                                                <v-icon v-if="isActivePermission(item)" color="blue">mdi-checkbox-marked</v-icon>
                                                <v-icon v-else color="blue">mdi-checkbox-blank-outline</v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                        <template v-for="sitem in item.subpermissions">
                                            <v-card-actions class="ma-0 pa-0 mx-1">
                                                <v-hover v-slot="{ hover }">
                                                    <v-card width="100%"
                                                            class="ma-0 pa-0 mb-1"
                                                            :elevation="0"
                                                            :color="hover ? 'grey lighten-4':'grey lighten-5'">
                                                        <v-card-actions class="ma-0 pa-0 mx-2">
                                                            <v-icon size="15" style="margin-top: -5px">mdi-arrow-right-bottom</v-icon>
                                                            <div class="blue-grey--text" style="margin-left: 10px; font-size:0.9em">{{sitem.name}}</div>
                                                            <div class="grey--text" style="margin-left: 10px; font-size:0.8em">{{sitem.message}}</div>
                                                            <v-spacer></v-spacer>
                                                            <v-btn icon @click="onPressCheckbox(sitem)">
                                                                <v-icon v-if="isActivePermission(sitem)" color="blue">mdi-checkbox-marked</v-icon>
                                                                <v-icon v-else color="blue">mdi-checkbox-blank-outline</v-icon>
                                                            </v-btn>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-hover>

                                            </v-card-actions>
                                        </template>
                                    </v-card>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                </v-card>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="settingPermissions"
                        class="ma-2"
                        color="primary"
                        @click="onPressUse">Apply
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";

export default {
    name: "p-edit-permissions-popup",
    props: {},
    data: () => ({
        settingPermissions: false,
        dialog: false,
        user: null,
        userPermissions:null,
    }),
    computed: {
        appPermisions(){
            return PermissionsStoreUtils.APP_PERMISSIONS()
        }
    },
    methods: {
        isActivePermission(permission){
            if (this.user == null){return false}
            if (this.userPermissions == null){return false}
            return this.userPermissions[permission.id]
        },
        onPressCheckbox(permission){
            if (this.userPermissions == null){this.userPermissions = {}}
            if (this.userPermissions[permission.id] == undefined ){this.userPermissions[permission.id] = false}
            this.userPermissions[permission.id] = !this.userPermissions[permission.id]
            this.$forceUpdate()
        },
        show(user) {
            this.user = user
            this.dialog = true
            let permissions = PermissionsStoreUtils.getAllPermission(this.user.uid)
            this.userPermissions = JSON.parse(JSON.stringify(permissions));
        },
        hide() {
            this.dialog = true
        },
        onClose() {
            this.dialog = false
        },
        onPressUse() {
            if (this.user == null){return}
            this.settingPermissions = true

            // remove keys with false value
            for (var key in this.userPermissions) {
                if (this.userPermissions[key] == false){
                    delete this.userPermissions[key];
                }
            }

            PermissionsStoreUtils.setUserAppPermission(this.user.uid, this.userPermissions)
            .then(() => {
                this.settingPermissions = false
                this.dialog = false
                this.$notify({title: 'Permissions successfully updated!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.settingPermissions = false
                this.dialog = false
                this.$notify({title: 'Permissions update failed!', text: error, type: "error"});
            })
        }
    }

}
</script>

<style scoped>

</style>